import CompanySelector from '../../pages/CompanySelector';

// Nome simples (PT): Página para Selecionar Empresa
export default function PaginaSelecionarEmpresa(props) {
  return <CompanySelector {...props} />;
}






